import 'bootstrap/dist/css/bootstrap.min.css';
import FeedsenseRoutes from './routes/FeedsenseRoutes';
import './App.css'
import "./theme/Switch_theme.scss"
import { useDispatch,useSelector } from 'react-redux';
import { Slide, ToastContainer, toast }from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from 'js-cookie';
import { setNotification } from './store/notificationSlice';
import { customToast } from './components/toastify/CustomToastify';
import { setLiveSentiment, updateCurrentCandle } from './store/liveSentimentSlice';
import pushNotification, { accessChecking, isNotificationEnabled } from './services/util/util';
import { useSocketEvent } from './store/hooks/useSocketEvent';

const App = () => {
  const dispatch = useDispatch();
    
  

const notify = (data: any) => {
  toast.success(
    `New trade entered at ${data?.dt_entry_time} of ${data?.s_code}`,
    {
      toastId: "unique-success-toast",
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Slide,
    }
  );
  pushNotification(`${data?.s_code}, New trade entered at ${data?.dt_entry_time}.`)
}

useSocketEvent('Nifty50Update', (data:any) => {
  // Get the current minute
  const currentMinute = new Date().toLocaleTimeString().slice(0,6)+'00';
  const currentCandleData = data;
  if (currentCandleData) {
    // Dispatch the update for the current minute's candle
    dispatch(updateCurrentCandle({ time: currentMinute, ohlc: currentCandleData }));
  }
},[])


  useSocketEvent('Nifty50Inserted', (data:any) => {
    const currentMinute = new Date().toLocaleTimeString().slice(0,6)+'00';
    const currentCandleData = data;
    dispatch(setLiveSentiment({ time: currentMinute, ohlc: currentCandleData }));
  },[])


  useSocketEvent('insert_row', (data:any)=>{
    
    let isLoggedIn:any = Cookies.get('details') ? Cookies.get('details') : JSON?.stringify([])
    if((JSON.parse(isLoggedIn)?.isLoggedIn || false) ){
      let cookiesCodesArr: any = Cookies.get('codesArray') || []
      if (JSON?.parse(cookiesCodesArr)?.includes(accessChecking(data)) && isNotificationEnabled()) {
  
          let formattedNotification: any = {
            "time": data?.dt_entry_time,
            "value": `New trade insert for ${data?.s_code}`,
            "Type": "insert",
            "s_code": data?.s_code,
            date:data?.dt_date,
            "s_symbol" : data?.s_symbol
          }
          notify(data);
          let notificationData: any = localStorage.getItem('notification')
          notificationData = notificationData ? JSON.parse(notificationData) : [];
          notificationData?.push(formattedNotification)
          notificationData = JSON.stringify(notificationData)
          localStorage.setItem('notification', notificationData)
          dispatch(setNotification(formattedNotification))
        }}
  
  
    }, [])


    useSocketEvent('trade_closed', (data:any)=>{
    
      let isLoggedIn:any = Cookies.get('details') ? Cookies.get('details') : JSON?.stringify([])
      if((JSON.parse(isLoggedIn)?.isLoggedIn || false) ){
        let cookiesCodesArr: any = Cookies.get('codesArray') || []
        if (JSON?.parse(cookiesCodesArr)?.includes(accessChecking(data)) && isNotificationEnabled()) {
    
            let formattedNotification: any = {
              "time": data?.dt_exit_time,
              "value": `Trade closed, Due to ${data?.s_status} with pl ${data?.n_pl}`,
              "Type": "closed",
              "s_code": data?.s_code,
              date:data?.dt_date,
              "s_symbol" : data?.s_symbol
            }
            customToast(data,'delete');
            let notificationData: any = localStorage.getItem('notification')
            notificationData = notificationData ? JSON.parse(notificationData) : [];
            notificationData?.push(formattedNotification)
            notificationData = JSON.stringify(notificationData)
            localStorage.setItem('notification', notificationData)
            dispatch(setNotification(formattedNotification))
          }}
    
    
      }, [])


 useSocketEvent('tsl_update',(data:any)=>{
    let isLoggedIn:any = Cookies.get('details') ? Cookies.get('details') : JSON?.stringify([])
    if((JSON.parse(isLoggedIn)?.isLoggedIn || false) ){
      let cookiesCodesArr: any = Cookies.get('codesArray') || []

      if (JSON?.parse(cookiesCodesArr)?.includes(data?.s_code) && isNotificationEnabled()) {
      customToast(data,'tsl_update')
      if (data?.Target === ''){ 
        pushNotification(`${data?.s_code}, Stoploss Modified to ${Number(data?.Stoploss)?.toFixed(2)} at ${data?.time}`) 
      }
      else if (data?.Stoploss === '') {  
        pushNotification(`${data?.s_code}, Target Modified to ${Number(data?.Target)?.toFixed(2)} at ${data?.time}`) 
      }
      else if (data?.Target &&  data?.Stoploss){ 
        pushNotification(`${data?.s_code}, Target Modified to ${Number(data?.Target)?.toFixed(2)} and Stoploss Modified to ${Number(data?.Stoploss)?.toFixed(2)} at ${data?.time}`)
      }
      
        let notificationData: any = localStorage.getItem('notification') //? JSON.parse(localStorage.getItem('notification')) : JSON.parse([])
        notificationData = notificationData ? JSON.parse(notificationData) : [];
        notificationData?.push(data)
        notificationData = JSON.stringify(notificationData)

        localStorage.setItem('notification', notificationData)
        dispatch(setNotification(data))
    }}
    
  },[])


return (
   <>
    <div className="app">
      <ToastContainer closeOnClick limit={7}/>
      <FeedsenseRoutes toast={toast}/>
    </div>
   </>
  )
}

export default App